import { useComments } from "@hooks";
import { observer } from "mobx-react";
import Presentation from "./CommentsDrawer";

interface Props {
  open: boolean;
  tenantId: number;
  averageRate: number;
  rateCount: number;
  onClose: () => void;
}

const CommentsDrawer: React.FC<Props> = observer(
  ({ open, tenantId, averageRate, rateCount, onClose }) => {
    const commentsHook = useComments(tenantId, open);

    return (
      <Presentation
        open={open}
        commentsHook={commentsHook}
        averageRate={averageRate}
        rateCount={rateCount}
        onClose={onClose}
      />
    );
  },
);

export default CommentsDrawer;
